import { Routes, Route, Navigate } from 'react-router-dom';
import React from 'react';
import './App.css';
import { HomeLayout } from './pages/Home';
import { ProtectedRoute } from './pages/Authentication/ProtectedRoute';
import Login from './pages/Authentication/Login';
import { CampaignManagement, AttachRules, NewCampaign, ViewCampaign } from './pages/CampaignManagement';
import { NewRule, RuleManagement, ViewRule } from './pages/RuleManagement';

function App() {
  return (
    <Routes>
      {/* Public route */}
      <Route path="/login" element={<Login />} />

      {/* Protected routes with HomeLayout */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <HomeLayout />
          </ProtectedRoute>
        }
      >
        <Route path="campaigns" element={<CampaignManagement />} />
        <Route path="campaigns/campaign/:campaignId" element={<ViewCampaign />} />
        <Route path="campaigns/campaign/attach-rules/campaign/:campaignId" element={<AttachRules />} />
        <Route path="campaigns/create" element={<NewCampaign />} />
        <Route path="rules" element={<RuleManagement />} />
        <Route path="rules/create" element={<NewRule />} />
        <Route path="rules/rule/:ruleId" element={<ViewRule />} />
      </Route>

      {/* Catch all route - redirect to campaigns if authenticated, otherwise to login */}
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <Navigate to="/" replace />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
